import React from 'react';
import { Button } from 'reactstrap';
import { RefreshCw, PlusCircle } from 'react-feather';

const EmptyState = ({ onAddNew }) => {
  return (
    <div className="text-center my-5 py-5">
      <RefreshCw size={100} className="text-muted opacity-50 mb-4" />
      <h4 className="text-muted mb-2">Chưa có minigame nào</h4>
      <p className="text-muted mb-4">
        Tạo minigame đầu tiên cho vòng quay may mắn
      </p>
      <Button color="success" size="lg" onClick={onAddNew}>
        <PlusCircle size={18} className="me-2" />
        Tạo Minigame Đầu Tiên
      </Button>
    </div>
  );
};

export default EmptyState;

